'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$53() {
  this.bjZ = null;
  this.bk0 = false;
}
export { $c_Lpresto_PrestoRouter$$anon$53 as $c_Lpresto_PrestoRouter$$anon$53 };
$p = $c_Lpresto_PrestoRouter$$anon$53.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$53;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$53() {
}
export { $h_Lpresto_PrestoRouter$$anon$53 as $h_Lpresto_PrestoRouter$$anon$53 };
$h_Lpresto_PrestoRouter$$anon$53.prototype = $p;
$p.bW = (function() {
  if ((!this.bk0)) {
    this.bjZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bk0 = true;
  }
  return this.bjZ;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$53 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$53, "presto.PrestoRouter$$anon$53", ({
  Ol: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$53 as $d_Lpresto_PrestoRouter$$anon$53 };
//# sourceMappingURL=presto.-Presto-Router$$anon$53.js.map
